module.exports = __webpack_public_path__ + "static/media/account.bb736c90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account.png
// module id = 870
// module chunks = 3